<template>
  <div class="component_container">
    <div class="flex-row justify-center align-center" v-if="loadMore">
      <van-loading color="#1989fa" size="25px"/>
      &nbsp;
      <span class="loadText">加载中...</span>
    </div>
    <div class="flex-row justify-center align-center" v-else>
      <span class="loadText">已加载完毕</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadMore",
  props: {
    loadMore: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style scoped>
.component_container{
  width: 100%;
  padding: 12px;
}
.loadText{
  font-size: 16px;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/loadMore.vue